import { AuthPayload } from '../components/page/SignIn/authFlow';
import { jwtDecode } from 'jwt-decode';

export default class Auth {
  static authInfo: AuthPayload | null = null;
  static oAuthToken: string;

  static setAuthInfo(authInfo: AuthPayload) {
    Auth.authInfo = authInfo;
  }

  static getAuthInfo() {
    return Auth.authInfo;
  }

  static setOAuthToken(token: string) {
    Auth.oAuthToken = token;
  }

  static getOAuthToken() {
    return Auth.oAuthToken;
  }

  static clearAuthInfo() {
    Auth.authInfo = null;
    Auth.oAuthToken = '';
  }

  static jwtDecode(accessToken: string) {
    if (!accessToken) {
      return null;
    }

    try {
      return jwtDecode<AuthPayload>(accessToken);
    } catch {
      return null;
    }
  }

  static setDefaultTenant(tenantId: string) {
    if (!tenantId) {
      return;
    }

    localStorage.setItem('defaultTenant', tenantId);
  }
}
